<template>
    <td-dialog :title="$t(title)" :before-close="cancel" :visible.sync="dialogsubGroVisible" width="660px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formInfo" ref="formInfo" :rules="rules" label-position="right" label-width="88px">
            <el-row>
                <el-col span="12">
                    <el-form-item :label="$t('common.ALARM_SUBSCRIPTION_NUMBER')" prop="sId">
                        <td-input v-model="formInfo.sId" :disabled="sIdDisabled" maxlength="50"></td-input>
                    </el-form-item>
                </el-col>
                <el-col span="12">
                    <el-form-item :label="$t('common.NAME')" prop="sName">
                        <td-input v-model="formInfo.sName" maxlength="50"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col span="12">
                    <el-row>
                        <el-col span="1" style="padding-top:18px">
                            <td-checkbox v-model="formInfo.sDeviceTypeIdCheck"></td-checkbox>
                        </el-col>
                        <el-col span="12">
                            <el-form-item :label="$t('common.DEVICE_TYPE')" prop="sDeviceTypeId" label-width="75px">
                                <td-select
                                    v-model="formInfo.sDeviceTypeId"
                                    keys="iId"
                                    text="sName"
                                    :options="deviceTypeList"
                                    :multiple="true"
                                    :collapse-tags="true"
                                    :placeholder="$t('common.PLEASE_SELECT')"
                                    :disabled="!formInfo.sDeviceTypeIdCheck"
                                ></td-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col span="12">
                    <el-row>
                        <el-col span="1" style="padding-top:18px">
                            <td-checkbox v-model="formInfo.sDeviceIdCheck"></td-checkbox>
                        </el-col>
                        <el-col span="12">
                            <el-form-item :label="$t('pgCommon.ALARM_DEVICE')" prop="sDeviceId" label-width="75px">
                                <td-tree-select
                                    ref="TdDeviceTree"
                                    :lazyloading="true"
                                    :defaultProps="deviceProps"
                                    :checkStrictly="false"
                                    :isSingleCheck="false"
                                    :showBox="true"
                                    :inputShow="true"
                                    nodeKey="id"
                                    :multiple="true"
                                    :imgloading="true"
                                    :isDistributed="false"
                                    @queryData="queryDeviceTreeData"
                                    @querySearchData="queryDeviceSearchData"
                                    :isPaging="true"
                                    :calInternal="false"
                                    :params="params"
                                    :customProp="customProp"
                                    :popoverShow="formInfo.sDeviceIdCheck"
                                    v-model="formInfo.sDeviceId"
                                    :filter="filter"
                                ></td-tree-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row>
                <el-col span="12">
                    <el-row>
                        <el-col span="1" style="padding-top:18px">
                            <td-checkbox v-model="formInfo.sAlarmTypeIdCheck"></td-checkbox>
                        </el-col>
                        <el-col span="12">
                            <el-form-item :label="$t('pgCommon.ALARM_GROUP')" prop="sAlarmTypeId" label-width="75px">
                                <td-tree-select
                                    ref="TdAlarmTypeTree"
                                    :treeList="alarmTypeList"
                                    :lazyloading="lazyloading"
                                    :defaultProps="defaultProps"
                                    :isSingleCheck="isSingleCheck"
                                    :inputShow="inputShow"
                                    :nodeKey="nodeKey"
                                    :expandAll="expandAll"
                                    :multiple="false"
                                    :popoverShow="formInfo.sAlarmTypeIdCheck"
                                ></td-tree-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col span="12">
                    <el-row>
                        <el-col span="1" style="padding-top:18px">
                            <td-checkbox v-model="formInfo.sAlarmEventIdCheck"></td-checkbox>
                        </el-col>
                        <el-col span="12">
                            <el-form-item :label="$t('common.ALARM_TYPE')" prop="sAlarmEventId" label-width="75px">
                                <td-select
                                    v-model="formInfo.sAlarmEventId"
                                    :multiple="true"
                                    keys="sId"
                                    text="sName"
                                    :collapse-tags="true"
                                    :options="alarmEventList"
                                    :placeholder="$t('common.PLEASE_SELECT')"
                                    :disabled="!formInfo.sAlarmEventIdCheck"
                                ></td-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row>
                <el-col span="12">
                    <el-row>
                        <el-col span="1" style="padding-top:18px">
                            <td-checkbox v-model="formInfo.sAlarmLevelIdCheck"></td-checkbox>
                        </el-col>
                        <el-col span="12">
                            <el-form-item :label="$t('common.ALARM_LEVEL')" prop="sAlarmLevelId" label-width="75px">
                                <td-select
                                    v-model="formInfo.sAlarmLevelId"
                                    keys="sId"
                                    text="sName"
                                    :options="alarmLevelList"
                                    :multiple="true"
                                    :collapse-tags="true"
                                    :placeholder="$t('common.PLEASE_SELECT')"
                                    :disabled="!formInfo.sAlarmLevelIdCheck"
                                >
                                </td-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col span="12">
                    <el-row>
                        <el-col span="1" style="padding-top:18px">
                            <td-checkbox v-model="formInfo.userAuthCheck"></td-checkbox>
                        </el-col>
                        <el-col span="12">
                            <el-form-item :label="$t('pgCommon.USER_AUTH')" label-width="75px">
                                <td-checkbox v-if="formInfo.userAuthCheck" v-model="formInfo.userOnlineCheck">{{ $t('pgCommon.USER_ONLINE') }}</td-checkbox>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <alarm-time ref="alarmTime" :timeLable="timeLable" v-if="dialogAdvancedVisible" :dialogAdvancedVisible="dialogAdvancedVisible"></alarm-time>
            <el-form-item :label="$t('common.DESCRIPTION')" prop="sDescribe">
                <td-input v-model="formInfo.sDescribe" type="textarea" maxlength="100"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.ENABLE')" prop="iStartStatus">
                <td-checkbox v-model="formInfo.iStartStatus"></td-checkbox>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="saveLoading" @click="submitForm('formInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import api from '../assets/api.js';
import alarmTime from './alarmTimeLable.vue';
export default {
    props: ['title', 'dialogsubGroVisible', 'editItem', 'isAddData', 'sIdDisabled', 'alarmLevelList', 'deviceTypeList', 'alarmTypeList', 'alarmEventList'],
    // 初始化渲染
    components: {
        'alarm-time': alarmTime
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        // 为编辑状态则进行初始化数据
        this.$nextTick(function() {
            if (!this.isAddData) {
                this.initEditData();
            }
        });
    },
    // 定义变量
    data() {
        let validateSId = (rule, value, callback) => {
            if (!this.isAddData) {
                callback();
                return;
            }
            let param = {
                sId: value,
                isAddData: this.isAddData,
                iType: 1
            };
            api.checkRepeat(param, response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    callback(response.data.statusMessage);
                    this.saveLoading = false;
                    return;
                } else {
                    callback();
                }
            });
        };
        let validateSName = (rule, value, callback) => {
            let param = {
                sName: value,
                isAddData: this.isAddData,
                iType: 1
            };
            if (!this.isAddData) {
                param.sId = this.editItem.sId;
            }
            api.checkRepeat(param, response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    callback(response.data.statusMessage);
                    this.saveLoading = false;
                    return;
                } else {
                    callback();
                }
            });
        };
        return {
            triggerDeviceType: [],
            deviceData: [],
            // mq表单信息
            formInfo: {
                sId: '',
                sName: '',
                sAlarmLevelId: [],
                iStartStatus: false,
                sAlarmEventId: [],
                sDeviceTypeIdCheck: false,
                sDeviceIdCheck: false,
                sAlarmTypeIdCheck: false,
                sAlarmEventIdCheck: false,
                sAlarmLevelIdCheck: false,
                sPrimaryId: '',
                userAuthCheck: false,
                userOnlineCheck: false
            },
            filter: [
                {
                    field: 'device',
                    value: false
                }
            ],
            groupDimension: [
                {
                    value: this.$common.groupDimension.ALARM_ALL_MESSAGE,
                    label: this.$t('common.ALARM_ALL_MESSAGE')
                },
                {
                    value: this.$common.groupDimension.ALARM_LEVEL,
                    label: this.$t('common.ALARM_LEVEL')
                },
                {
                    value: this.$common.groupDimension.ALARM_TYPE,
                    label: this.$t('common.ALARM_TYPE')
                },
                {
                    value: this.$common.groupDimension.ALARM_EVENT_AND_DEVICE,
                    label: this.$t('common.ALARM_EVENT_AND_DEVICE')
                },
                {
                    value: this.$common.groupDimension.DEVICE_TYPE,
                    label: this.$t('common.DEVICE_TYPE')
                }
            ],
            timeLable: this.$t('common.ALARM_DATE'),
            sAlarmTypeIdShow: true,
            sAlarmLevelIdShow: true,
            sDeviceTypeIdShow: true,
            sDeviceIdShow: true,
            sAlarmEventIdShow: true,
            saveLoading: false,
            dialogAdvancedVisible: true,
            customProp: ['noPermission'],
            alarmEventDataList: [],
            defaultProps: {
                children: 'children',
                label: 'typeName',
                id: 'id'
            },
            lazyloading: false,
            isSingleCheck: true,
            inputShow: true,
            expandAll: true,
            isClick: true,
            nodeKey: 'id',
            deviceList: [],
            deviceLazyload: true,
            interfaceName: { query: '/device/queryDeviceOrgTree', search: '/device/queryDeviceOrgTreeByName' },
            params: {
                includeSelf: true, // 查询条件是否包含自己
                parentId: '',
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS
            },
            deviceProps: {
                children: 'children',
                label: 'caption',
                id: 'id',
                imgName: 'sIcon',
                parentId: 'parentId'
            },
            echoFlag: false,
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') },
                    { validator: validateSName, trigger: 'blur' }
                ],
                sId: [
                    { required: true, message: this.$t('pgRegex.PLEASE_ENTER_SUBSCRIPTION_NUMBER_ALARM_GROUP'), trigger: 'blur' },
                    { pattern: this.$regex.PASSWORD_RULE, message: this.$t('pgRegex.ONLY_NUMBERS_AND_LETTERS_ARE_ALLOWED') },
                    { validator: validateSId, trigger: 'blur' }
                ],
                sDescribe: [{ min: 1, max: 100, message: this.$t('error.ERROR_DESCRIPTION_MAX_LENGTH'), trigger: 'blur' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formInfo.sName = this.editItem.sName;
            this.formInfo.sId = this.editItem.sId;
            this.formInfo.sDescribe = this.editItem.sDescribe;
            this.formInfo.sPrimaryId = this.editItem.sPrimaryId;
            this.formInfo.iStartStatus = this.editItem.iStartStatus !== 0;
            this.formInfo.userAuthCheck = this.editItem.iUserAuth !== 0;
            this.formInfo.userOnlineCheck = this.editItem.iUserOnline !== 0;
            this.initGroupDimension();
            let alarmTime = {};
            alarmTime.iTimeMode = this.editItem.iAlarmTimeMode;
            alarmTime.sDateTime = JSON.parse(this.editItem.sDateTime);
            this.$refs.alarmTime.initData(alarmTime);
        },
        //初始化分组信息
        initGroupDimension() {
            this.initDeviceType();
            this.initAlarmDevice();
            this.initAlarmType();
            this.initAlarmEvent();
            this.initAlarmLevel();
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let alarmData = this.$refs.alarmTime.getData();
                    if (null == alarmData) {
                        return;
                    }
                    this.saveLoading = true;
                    let content = {
                        sName: this.formInfo.sName,
                        sId: this.formInfo.sId,
                        sPrimaryId: this.formInfo.sPrimaryId,
                        iType: 1,
                        iStartStatus: this.formInfo.iStartStatus ? '1' : '0',
                        sDescribe: this.formInfo.sDescribe,
                        iAlarmTimeMode: alarmData.iTimeMode,
                        sDateTime: alarmData.sDateTime,
                        isAddData: this.isAddData
                    };
                    //设备类型
                    if (this.formInfo.sDeviceTypeIdCheck) {
                        content.sDeviceTypeId = this.formInfo.sDeviceTypeId;
                    }
                    //报警设备
                    if (this.formInfo.sDeviceIdCheck) {
                        let sDeviceId = [];
                        if (this.formInfo.sDeviceId) {
                            for (let i = 0; i < this.formInfo.sDeviceId.length; i++) {
                                sDeviceId.push(this.formInfo.sDeviceId[i].sId);
                            }
                            content.sDeviceId = sDeviceId;
                        }
                    }
                    //报警类型
                    if (this.formInfo.sAlarmTypeIdCheck) {
                        let alarmTypeNode = this.$refs.TdAlarmTypeTree.getSelectedNodes();
                        content.sAlarmTypeId = alarmTypeNode ? [alarmTypeNode.id] : '';
                    }
                    //报警事件
                    if (this.formInfo.sAlarmEventIdCheck) {
                        content.sAlarmEventId = this.formInfo.sAlarmEventId;
                    }
                    //报警级别
                    if (this.formInfo.sAlarmLevelIdCheck) {
                        content.sAlarmLevelId = this.formInfo.sAlarmLevelId;
                    }
                    //用户权限
                    content.iUserAuth = 0;
                    content.iUserOnline = 0;
                    if (this.formInfo.userAuthCheck) {
                        content.iUserAuth = 1;
                        //在线用户
                        if (this.formInfo.userOnlineCheck) {
                            content.iUserOnline = 1;
                        }
                    }

                    api.saveAlarmSubscribeGroup(content, response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('alarm/saveAlarmSubscribeGroup', response.data.statusMessage);
                            this.saveLoading = false;
                            return;
                        }
                        this.saveLoading = false;
                        let message = this.$t('common.ADD_SUCCESS');
                        if (!this.isAddData) {
                            message = this.$t('common.MODIFY_SUCCESS');
                        }
                        this.$message({ showClose: true, message: message, type: 'success' });
                        this.subGroDialogClose();
                    });
                }
            });
        },
        // 初始化报警类型
        initAlarmType: function() {
            if (this.editItem.sAlarmTypeId && this.editItem.sAlarmTypeId.length > 0) {
                this.formInfo.sAlarmTypeIdCheck = true;
                let obj = {};
                obj.typeName = this.editItem.alarmTypeContent;
                obj.id = this.editItem.sAlarmTypeId[0];
                this.$refs.TdAlarmTypeTree.dataDisplay([obj]);
            }
        },
        // 初始化设备类型
        initDeviceType: function() {
            if (this.editItem.sDeviceTypeId) {
                this.formInfo.sDeviceTypeIdCheck = true;
                let sDeviceTypeIdArr = [];
                for (let i = 0; i < this.editItem.sDeviceTypeId.length; i++) {
                    sDeviceTypeIdArr.push(parseInt(this.editItem.sDeviceTypeId[i]));
                }
                this.formInfo.sDeviceTypeId = sDeviceTypeIdArr;
            }
        },
        // 初始化报警设备
        initAlarmDevice: function() {
            if (this.editItem.alarmDeviceVoList != null && this.editItem.alarmDeviceVoList.length > 0) {
                this.formInfo.sDeviceIdCheck = true;
                let deviceSId = [];
                for (let i = 0; i < this.editItem.alarmDeviceVoList.length; i++) {
                    let alarmDevice = this.editItem.alarmDeviceVoList[i];
                    deviceSId.push(alarmDevice.id);
                }
                api.queryDeviceInfoByIds(deviceSId, response => {
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('device/queryDeviceInfoByIds', response.data.statusMessage);
                        this.saveLoading = false;
                        return;
                    }
                    this.deviceData = response.data.content;
                    let deviceSid = [];
                    this.deviceData.forEach(item => {
                        deviceSid.push(item.sId);
                    });
                    if (deviceSid.length > 0) {
                        api.queryDeviceOrgInfoById(deviceSid, response => {
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('device/queryDeviceOrgInfoById', response.data.statusMessage);
                                this.saveLoading = false;
                                return;
                            }
                            let deviceOrg = response.data.content;
                            if (deviceOrg && deviceOrg.length > 0) {
                                for (let i = 0; i < this.deviceData.length; i++) {
                                    let orgId = '21dsec1d-4a27-48d1-we4c5-e44fcc23110';
                                    for (let j = 0; j < deviceOrg.length; j++) {
                                        if (deviceOrg[j].sId == this.deviceData[i].sId) {
                                            if (deviceOrg[j].orgInfoVo && deviceOrg[j].orgInfoVo.length > 0) {
                                                orgId = deviceOrg[j].orgInfoVo[0].sOrgId;
                                            }
                                            break;
                                        }
                                    }
                                    this.deviceData[i].sOrgId = orgId;
                                }
                            }
                            let objArr = [];
                            for (let i = 0; i < this.deviceData.length; i++) {
                                let device = this.deviceData[i];
                                let obj = {};
                                obj.sId = device.sId;
                                obj.deviceType = device.iDeviceType;
                                obj.device = true;
                                obj.caption = device.sName;
                                obj.id = device.sOrgId + '_' + device.sId;
                                obj.parentId = device.sOrgId;
                                objArr.push(obj);
                                this.$refs.TdDeviceTree.areaUserList.push(obj);
                            }
                            this.$refs.TdDeviceTree.setCheckedNodes(objArr);
                        });
                    }
                });
            }
        },
        // 初始化报警事件
        initAlarmEvent: function() {
            if (this.editItem.sAlarmEventId != null && this.editItem.sAlarmEventId !== '') {
                this.formInfo.sAlarmEventIdCheck = true;
                this.formInfo.sAlarmEventId = this.editItem.sAlarmEventId;
            }
        },
        //初始化报警级别
        initAlarmLevel: function() {
            if (this.editItem.sAlarmLevelId != null && this.editItem.sAlarmLevelId !== '') {
                this.formInfo.sAlarmLevelIdCheck = true;
                this.formInfo.sAlarmLevelId = this.editItem.sAlarmLevelId;
            }
        },
        queryDeviceTreeData: function(item) {
            //查询报警设备类型
            if (this.triggerDeviceType.length == 0) {
                api.getDeviceTypeList('', response => {
                    let deviceType = response.data.content;
                    if (deviceType) {
                        for (let i = 0; i < deviceType.length; i++) {
                            this.triggerDeviceType.push(deviceType[i].iId);
                        }
                        this.deviceTreeData(item);
                    }
                });
            } else {
                this.deviceTreeData(item);
            }
        },
        //组织设备树
        deviceTreeData: function(item) {
            if (item.parentId === '' || item.parentId === null || item.parentId === undefined) {
                item.parentId = item.parentId = '';
            }
            let queryParam = {
                includeSelf: true, // 查询条件是否包含自己
                parentId: item.parentId,
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS,
                noPermission: item.noPermission,
                deviceTypeList: this.triggerDeviceType,
                currentPage: item.currentPage,
                pageSize: item.pageSize
            };
            api.findDeviceTree(JSON.stringify(queryParam), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/device/queryDeviceOrgTree', response.data.statusMessage);
                    return;
                }
                // 初始化树形数据
                this.$refs.TdDeviceTree.initData(response.data.content);
            });
        },
        queryDeviceSearchData: function(item) {
            //查询报警设备类型
            if (this.triggerDeviceType.length == 0) {
                api.getDeviceTypeList('', response => {
                    let deviceType = response.data.content;
                    if (deviceType) {
                        for (let i = 0; i < deviceType.length; i++) {
                            this.triggerDeviceType.push(deviceType[i].iId);
                        }
                        this.deviceSearchData(item);
                    }
                });
            } else {
                this.deviceSearchData(item);
            }
        },
        //组织设备树查询
        deviceSearchData: function(item) {
            let queryParam = {
                currentPage: item.currentPage,
                pageSize: item.pageSize,
                deviceTypeList: this.triggerDeviceType,
                caption: item.caption
            };
            api.queryDeviceOrgTreeByName(JSON.stringify(queryParam), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/device/queryDeviceOrgTreeByName', response.data.statusMessage);
                    return;
                }
                // 初始化树形数据
                this.$refs.TdDeviceTree.initData(response.data.content);
            });
        },
        // 取消
        cancel() {
            this.$emit('subGroDialogClose');
            this.$refs['formInfo'].resetFields(); // 重置表单数据
        },
        // 关闭窗口之前需要调用的方法
        subGroDialogClose() {
            this.cancel();
            this.$emit('submit');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
